module.exports = __webpack_public_path__ + "static/media/rollback.87e660d0.svg";